/**
 * Gate 3D, tracking consultivo leve
 * BLINDADO · Veltrus / Eyros Shopify Partner · https://eyros.com.br
 * Não alterar sem autorização Veltrus.
 *
 * E-commerce (view_item, add_to_cart, begin_checkout, purchase, cart_view):
 *   → Shopify native / Customer Events / app pixels (sem camada paralela).
 *
 * Custom dataLayer apenas para lead / WhatsApp / catálogo / guia / orçamento.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'g3d_utm_v1';
  var DAYS = 90;
  var PARTNER = {
    name: 'Veltrus',
    brand: 'Eyros',
    url: 'https://eyros.com.br',
    theme: 'gate3d'
  };

  /** Eventos consultivos permitidos, qualquer outro data-g3d-track é ignorado. */
  var ALLOWED = {
    whatsapp_click: true,
    quote_request: true,
    catalog_download: true,
    guide_resins_click: true,
    resin_comparison_view: true,
    printer_catalog_click: true,
    printer_specialist_click: true,
    /* aliases canônicos mantidos para CTAs legados */
    specialist_click: true,
    material_selector_submit: true,
    welcome_offer_click: true,
    veltrus_partner_click: true
  };

  /** Aliases legados / prefixos de seção → evento canônico (allowlist) */
  var ALIASES = {
    welcome_banner_click: 'welcome_offer_click',
    machine_interest: 'printer_specialist_click',
    banner_specialist_click: 'printer_specialist_click',
    specialist_click: 'printer_specialist_click',
    banner_catalog_click: 'catalog_download',
    banner_guide_click: 'guide_resins_click',
    /* image banners (tracking_prefix + *_track no theme editor) */
    image_banner_guide_resins_click: 'guide_resins_click',
    image_banner_catalog_click: 'catalog_download',
    image_banner_machines_click: 'printer_catalog_click',
    image_banner_specialist_click: 'printer_specialist_click',
    /* campaign / entry aliases extras */
    banner_machines_click: 'printer_catalog_click',
    entry_impressoras: 'printer_catalog_click'
  };

  function now() {
    return Date.now();
  }

  function uuid() {
    return 'g3d_' + now().toString(36) + '_' + Math.random().toString(36).slice(2, 10);
  }

  function readParams() {
    var out = {};
    try {
      var q = window.location.search.replace(/^\?/, '').split('&');
      for (var i = 0; i < q.length; i++) {
        if (!q[i]) continue;
        var parts = q[i].split('=');
        var k = decodeURIComponent(parts[0] || '');
        var v = decodeURIComponent((parts[1] || '').replace(/\+/g, ' '));
        if (k) out[k] = v;
      }
    } catch (e) {}
    return out;
  }

  function loadUtm() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !data.expires || data.expires < now()) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return data.values || null;
    } catch (e) {
      return null;
    }
  }

  function saveUtm(values) {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ expires: now() + DAYS * 24 * 60 * 60 * 1000, values: values })
      );
      document.cookie =
        STORAGE_KEY +
        '=' +
        encodeURIComponent(JSON.stringify(values)) +
        ';path=/;max-age=' +
        String(DAYS * 24 * 60 * 60) +
        ';SameSite=Lax';
    } catch (e) {}
  }

  function captureUtm() {
    var params = readParams();
    var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid'];
    var found = false;
    var values = loadUtm() || {};
    for (var i = 0; i < keys.length; i++) {
      if (params[keys[i]]) {
        values[keys[i]] = params[keys[i]];
        found = true;
      }
    }
    if (found) saveUtm(values);
    return loadUtm() || values || {};
  }

  function fillUtmFields() {
    var utm = loadUtm() || {};
    var fields = document.querySelectorAll('[data-g3d-utm]');
    for (var i = 0; i < fields.length; i++) {
      var key = fields[i].getAttribute('data-g3d-utm');
      if (key && utm[key]) fields[i].value = utm[key];
    }
  }

  function resolveEventName(raw) {
    if (!raw) return '';
    var name = String(raw).trim();
    if (ALIASES[name]) name = ALIASES[name];
    if (!ALLOWED[name]) return '';
    return name;
  }

  /**
   * Payload mínimo consultivo (sem ecommerce paralelo).
   */
  function basePayload(eventName, extra) {
    var utm = loadUtm() || {};
    var payload = {
      event: eventName,
      event_name: eventName,
      event_id: uuid(),
      page_url: window.location.href,
      cta_label: '',
      product_name: '',
      product_type: '',
      utm_source: utm.utm_source || '',
      utm_medium: utm.utm_medium || '',
      utm_campaign: utm.utm_campaign || '',
      utm_content: utm.utm_content || '',
      utm_term: utm.utm_term || '',
      gclid: utm.gclid || '',
      fbclid: utm.fbclid || ''
    };

    if (extra) {
      if (extra.cta_label) payload.cta_label = String(extra.cta_label).trim();
      if (extra.product_name) payload.product_name = String(extra.product_name).trim();
      /* product_type: prefer explicit; fallback product_family / category */
      if (extra.product_type) payload.product_type = String(extra.product_type).trim();
      else if (extra.product_family) payload.product_type = String(extra.product_family).trim();
      else if (extra.product_category) payload.product_type = String(extra.product_category).trim();
    }

    return payload;
  }

  /**
   * Encaminha eventos consultivos para GA4 (gtag) + Meta (fbq).
   * Storefront não usa GTM Web, dataLayer sozinho não chega nos ads.
   * Nunca reenvia ecommerce (view_item/ATC/purchase), isso fica no Shopify native.
   */
  function forwardToAds(payload) {
    var name = payload.event;
    var params = {
      send_to: 'G-6KZVH04VQ0',
      event_id: payload.event_id,
      page_location: payload.page_url,
      cta_label: payload.cta_label || undefined,
      product_name: payload.product_name || undefined,
      product_type: payload.product_type || undefined,
      utm_source: payload.utm_source || undefined,
      utm_medium: payload.utm_medium || undefined,
      utm_campaign: payload.utm_campaign || undefined
    };

    if (typeof window.gtag === 'function') {
      try {
        window.gtag('event', name, params);
        /* Key events já configurados na prop 435774569 */
        if (name === 'quote_request') {
          window.gtag('event', 'generate_lead', Object.assign({}, params, { lead_type: 'quote_request' }));
          window.gtag('event', 'form_submit', Object.assign({}, params, { form_name: 'quote_request' }));
        }
        if (name === 'catalog_download') {
          window.gtag('event', 'form_submit', Object.assign({}, params, { form_name: 'catalog_download' }));
        }
        if (name === 'whatsapp_click' || name === 'printer_specialist_click') {
          if (name !== 'whatsapp_click') {
            window.gtag('event', 'whatsapp_click', Object.assign({}, params, { source_event: name }));
          }
        }
      } catch (e) {}
    }

    if (typeof window.fbq === 'function') {
      try {
        var metaParams = {
          content_name: name,
          content_category: payload.product_type || undefined,
          cta_label: payload.cta_label || undefined
        };
        /* Standard events para otimização Meta, Purchase/ATC só via Shopify app pixel */
        if (name === 'quote_request') {
          window.fbq('track', 'Lead', metaParams, { eventID: payload.event_id });
        } else if (name === 'whatsapp_click' || name === 'printer_specialist_click') {
          window.fbq('track', 'Contact', metaParams, { eventID: payload.event_id + '_contact' });
          window.fbq('trackCustom', 'WhatsAppClick', metaParams, { eventID: payload.event_id });
        } else {
          window.fbq('trackCustom', name, metaParams, { eventID: payload.event_id });
        }
      } catch (e2) {}
    }
  }

  function push(eventName, extra) {
    var name = resolveEventName(eventName);
    if (!name) return null;
    window.dataLayer = window.dataLayer || [];
    var payload = basePayload(name, extra || {});
    window.dataLayer.push(payload);
    forwardToAds(payload);
    return payload;
  }

  function openModal(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.hidden = false;
    el.setAttribute('data-open', '1');
    document.documentElement.style.overflow = 'hidden';
    fillUtmFields();
    var focusable = el.querySelector('input, select, textarea, button');
    if (focusable) {
      try {
        focusable.focus();
      } catch (e) {}
    }
  }

  function closeModals() {
    var modals = document.querySelectorAll('[data-g3d-modal]');
    for (var i = 0; i < modals.length; i++) {
      modals[i].hidden = true;
      modals[i].removeAttribute('data-open');
    }
    document.documentElement.style.overflow = '';
  }

  function waUrl(message) {
    return 'https://api.whatsapp.com/send?phone=555432619936&text=' + encodeURIComponent(message);
  }

  function attrsFromEl(el) {
    return {
      cta_label: el.getAttribute('data-cta-label') || (el.textContent || '').trim(),
      product_name: el.getAttribute('data-product-name') || '',
      product_type:
        el.getAttribute('data-product-type') ||
        el.getAttribute('data-product-family') ||
        el.getAttribute('data-product-category') ||
        el.getAttribute('data-g3d-wa') ||
        ''
    };
  }

  function bindClicks() {
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      var openQuote = t.closest('[data-g3d-open-quote]');
      if (openQuote) {
        e.preventDefault();
        push('quote_request', attrsFromEl(openQuote));
        openModal('g3d-quote-modal');
        return;
      }

      var openCatalog = t.closest('[data-g3d-open-catalog]');
      if (openCatalog) {
        e.preventDefault();
        push(
          openCatalog.getAttribute('data-g3d-track') || 'catalog_download',
          attrsFromEl(openCatalog)
        );
        openModal('g3d-catalog-modal');
        return;
      }

      if (t.closest('[data-g3d-close-modal]')) {
        e.preventDefault();
        closeModals();
        return;
      }

      if (t.closest('[data-g3d-open-quote], [data-g3d-open-catalog]')) return;
      if (t.closest('form[data-g3d-quote-form] button, form[data-g3d-catalog-form] button')) return;

      var trackEl = t.closest('[data-g3d-track]');
      if (trackEl) {
        var ev = trackEl.getAttribute('data-g3d-track');
        push(ev, attrsFromEl(trackEl));
      }
    });
  }

  function bindEsc() {
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) closeModals();
    });
  }

  function bindForms() {
    var quoteForm = document.querySelector('[data-g3d-quote-form]');
    if (quoteForm) {
      quoteForm.addEventListener('submit', function (e) {
        e.preventDefault();
        fillUtmFields();
        var fd = new FormData(quoteForm);
        var interest = fd.get('interest') || 'orcamento';
        var text =
          'Olá, gostaria de solicitar orçamento técnico de impressão 3D.\n' +
          'Nome: ' + (fd.get('name') || '') + '\n' +
          'Empresa: ' + (fd.get('company') || '') + '\n' +
          'WhatsApp: ' + (fd.get('whatsapp') || '') + '\n' +
          'E-mail: ' + (fd.get('email') || '') + '\n' +
          'Interesse: ' + interest + '\n' +
          'Quantidade: ' + (fd.get('quantity') || '-') + '\n' +
          'Prazo: ' + (fd.get('deadline') || '-') + '\n' +
          'Observação: ' + (fd.get('message') || '-') + '\n' +
          'UTM: ' + (fd.get('utm_source') || '') + '/' + (fd.get('utm_campaign') || '');
        push('quote_request', {
          cta_label: 'Solicitar orçamento técnico',
          product_type: interest
        });
        window.open(waUrl(text), '_blank', 'noopener');
        closeModals();
      });
    }

    var catalogForm = document.querySelector('[data-g3d-catalog-form]');
    if (catalogForm) {
      catalogForm.addEventListener('submit', function (e) {
        e.preventDefault();
        fillUtmFields();
        var fd = new FormData(catalogForm);
        var interest = fd.get('interest') || 'completo';
        var text =
          'Olá, quero receber o catálogo de equipamentos Gate 3D.\n' +
          'Nome: ' + (fd.get('name') || '') + '\n' +
          'Empresa: ' + (fd.get('company') || '') + '\n' +
          'WhatsApp: ' + (fd.get('whatsapp') || '') + '\n' +
          'E-mail: ' + (fd.get('email') || '') + '\n' +
          'Interesse: ' + interest;
        push('catalog_download', {
          cta_label: 'Baixar catálogo',
          product_type: interest
        });
        window.open(waUrl(text), '_blank', 'noopener');
        closeModals();
      });
    }

    bindSelectorCards();
  }

  function bindSelectorCards() {
    var wrap = document.querySelector('[data-g3d-selector-cards]');
    if (!wrap) return;
    var map = {
      resina: {
        title: 'Catálogo de resinas técnicas',
        text: 'Comece pelas resinas Gate 3D, linha ativa para engenharia, flexíveis, dental e alta temperatura.',
        cta: 'Comparar soluções · Comprar resinas',
        href: '/collections/resinas'
      },
      filamento: {
        title: 'Filamentos Bambu Lab',
        text: 'Linha FDM ativa para prototipagem, engenharia e produção. Compre filamentos no catálogo Gate 3D.',
        cta: 'Comprar filamentos',
        href: '/collections/filamentos'
      },
      maquina: {
        title: 'Impressoras 3D',
        text: 'Solução consultiva B2B: compra, locação, cura UV, treinamento e suporte nacional.',
        cta: 'Ver equipamentos',
        href: '/pages/impressoras'
      },
      orcamento: {
        title: 'Impressão 3D sob medida',
        text: 'Envie o arquivo ou descreva a aplicação, retornamos com análise técnica e prazo.',
        cta: 'Solicitar orçamento técnico',
        href: '/pages/orcamento-b2b'
      }
    };
    var titleEl = document.querySelector('[data-g3d-reco-title]');
    var textEl = document.querySelector('[data-g3d-reco-text]');
    var ctaEl = document.querySelector('[data-g3d-reco-cta]');

    function apply(need) {
      var item = map[need] || map.resina;
      if (titleEl) titleEl.textContent = item.title;
      if (textEl) textEl.textContent = item.text;
      if (ctaEl) {
        ctaEl.textContent = item.cta;
        ctaEl.setAttribute('href', item.href === '#quote' ? '#' : item.href);
        ctaEl.setAttribute('data-product-family', need);
        if (item.href === '#quote') {
          ctaEl.setAttribute('data-g3d-open-quote', '1');
          ctaEl.removeAttribute('data-g3d-track');
        } else {
          ctaEl.removeAttribute('data-g3d-open-quote');
          ctaEl.setAttribute('data-g3d-track', 'material_selector_submit');
        }
      }
    }

    wrap.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-g3d-need]');
      if (!btn) return;
      var need = btn.getAttribute('data-g3d-need') || 'resina';
      var cards = wrap.querySelectorAll('[data-g3d-need]');
      for (var i = 0; i < cards.length; i++) {
        var on = cards[i] === btn;
        cards[i].classList.toggle('is-active', on);
        cards[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      }
      apply(need);
      push('material_selector_submit', {
        cta_label: (btn.textContent || '').trim(),
        product_type: need
      });
    });

    if (ctaEl) {
      ctaEl.addEventListener('click', function (e) {
        if (ctaEl.hasAttribute('data-g3d-open-quote')) {
          e.preventDefault();
          push('quote_request', { cta_label: 'Solicitar orçamento técnico', product_type: 'orcamento' });
          openModal('g3d-quote-modal');
        }
      });
    }
  }

  function bindTagFilters() {
    var wrap = document.querySelector('[data-g3d-tag-filters]');
    if (!wrap) return;
    wrap.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-g3d-tag]');
      if (!btn) return;
      var tag = (btn.getAttribute('data-g3d-tag') || '').toLowerCase();
      var chips = wrap.querySelectorAll('[data-g3d-tag]');
      for (var i = 0; i < chips.length; i++) chips[i].classList.toggle('is-active', chips[i] === btn);
      var cards = document.querySelectorAll('#product-grid .g3d-card, .product-grid .g3d-card');
      for (var j = 0; j < cards.length; j++) {
        var card = cards[j];
        var li = card.closest('.grid__item') || card;
        if (!tag) {
          li.style.display = '';
          continue;
        }
        var tags = (card.getAttribute('data-g3d-tags') || '').toLowerCase();
        var title = (card.textContent || '').toLowerCase();
        var isDental = title.indexOf('dental') !== -1 || tags.indexOf('dental') !== -1;
        var show =
          tags.indexOf(tag) !== -1 ||
          (tag === 'tecnica' && (title.indexOf('abs') !== -1 || title.indexOf('pc like') !== -1 || title.indexOf('nylon') !== -1 || title.indexOf('cera') !== -1 || tags.indexOf('engenharia') !== -1)) ||
          (tag === 'flexivel' && (title.indexOf('rubber') !== -1 || title.indexOf('tpu') !== -1 || title.indexOf('pu like') !== -1 || title.indexOf('silicone') !== -1)) ||
          (tag === 'transparente' &&
            !isDental &&
            (title.indexOf('cristal') !== -1 || title.indexOf('glass') !== -1 || (title.indexOf('clear') !== -1 && title.indexOf('dental') === -1))) ||
          (tag === 'alta-temperatura' && title.indexOf('temperatura') !== -1) ||
          (tag === 'lavavel' && !isDental && (title.indexOf('laváv') !== -1 || title.indexOf('lavav') !== -1 || title.indexOf('water wash') !== -1)) ||
          (tag === 'geral' && !isDental && (title.indexOf('general') !== -1 || title.indexOf('standard') !== -1 || title.indexOf('cinza') !== -1)) ||
          (tag === 'dental' && isDental);
        li.style.display = show ? '' : 'none';
      }
    });
  }

  function enhanceFloatingWa() {
    var links = document.querySelectorAll('a[href*="whatsapp"], a[href*="leadstaker"], a[href*="api.whatsapp.com"]');
    for (var i = 0; i < links.length; i++) {
      if (!links[i].getAttribute('data-g3d-track')) {
        links[i].setAttribute('data-g3d-track', 'whatsapp_click');
      }
    }
  }

  /** Uma vez por página quando a tabela do guia entra no viewport. */
  function observeResinGuide() {
    var el = document.querySelector('[data-g3d-resin-guide], [data-g3d-resin-table]');
    if (!el || typeof IntersectionObserver === 'undefined') return;
    var fired = false;
    var io = new IntersectionObserver(
      function (entries) {
        if (fired) return;
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting && entries[i].intersectionRatio >= 0.25) {
            fired = true;
            push('resin_comparison_view', { cta_label: 'Guia de resinas', product_type: 'resina' });
            try {
              io.disconnect();
            } catch (e) {}
            break;
          }
        }
      },
      { threshold: [0.25] }
    );
    io.observe(el);
  }

  function syncStickyHeights() {
    try {
      var ann =
        document.querySelector('#shopify-section-announcement-bar') ||
        document.querySelector('.announcement-bar-section') ||
        document.querySelector('.utility-bar');
      var nav =
        document.querySelector('sticky-header.header-wrapper') ||
        document.querySelector('.section-header') ||
        document.querySelector('header.header');
      var root = document.documentElement;
      if (ann && ann.offsetHeight) {
        root.style.setProperty('--g3d-ann-h', ann.offsetHeight + 'px');
      }
      if (nav && nav.offsetHeight) {
        root.style.setProperty('--g3d-nav-h', nav.offsetHeight + 'px');
      }
    } catch (e) {}
  }

  /** Trava leve de propriedade, não quebra a loja; sinaliza remoção do crédito/selo. */
  function partnerGuard() {
    try {
      window.__VELTRUS_THEME__ = PARTNER;
      var html = document.documentElement;
      var okPartner = html && html.getAttribute('data-veltrus-partner') === 'eyros';
      var credit = document.querySelector(
        '.g3d-footer__credit a[href*="eyros.com.br"], a[data-g3d-track="veltrus_partner_click"]'
      );
      if (!okPartner || !credit) {
        if (typeof console !== 'undefined' && console.warn) {
          console.warn(
            '[Veltrus/Eyros] Tema Gate 3D blindado, selo de parceiro ausente. ' +
              'Manutenção exclusiva: ' +
              PARTNER.url
          );
        }
      }
    } catch (e) {}
  }

  function init() {
    partnerGuard();
    captureUtm();
    fillUtmFields();
    bindClicks();
    bindEsc();
    bindForms();
    bindTagFilters();
    enhanceFloatingWa();
    observeResinGuide();
    syncStickyHeights();
    window.addEventListener('resize', syncStickyHeights, { passive: true });
    window.Gate3DTracking = {
      push: push,
      captureUtm: captureUtm,
      openQuote: function () {
        openModal('g3d-quote-modal');
      },
      openCatalog: function () {
        openModal('g3d-catalog-modal');
      },
      closeModals: closeModals,
      allowed: ALLOWED,
      partner: PARTNER
    };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
